/**
 * Payment Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentAccountSimpleDto } from './paymentAccountSimpleDto';
import { InvoiceSimpleDto } from './invoiceSimpleDto';


export interface TransactionDto { 
    id?: number;
    insertTs: string;
    amount?: number;
    currency?: TransactionDto.CurrencyEnum;
    transactionDate?: string;
    description: string;
    exchangeRateFromBaseToCurrency?: number;
    baseCurrency?: TransactionDto.BaseCurrencyEnum;
    paymentAccount: PaymentAccountSimpleDto;
    invoice?: InvoiceSimpleDto;
}
export namespace TransactionDto {
    export const CurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
    export const BaseCurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type BaseCurrencyEnum = typeof BaseCurrencyEnum[keyof typeof BaseCurrencyEnum];
}


export type BaseCurrencyEnum = typeof TransactionDto.BaseCurrencyEnum[keyof typeof TransactionDto.BaseCurrencyEnum];
